import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 查询所有运营员账号
    get: params => request.post(`${base.baseUrl}/yyyhao-cloud-system/user/getUserList`, params),
    //新增运营员
    add: params => request.post(`${base.baseUrl}/yyyhao-cloud-system/user/saveUser`, params),
    //修改运营员
    update: params => request.post(`${base.baseUrl}/yyyhao-cloud-system/user/updateUser`, params),
    //删除运营员
    del: params => request.post(`${base.baseUrl}/yyyhao-cloud-system/user/deleteUser`, params),
}